/* eslint-disable eqeqeq */
import {
  Avatar,
  Box,
  Container,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppBaseScreen from "../../components/AppBaseScreen";
import { theme } from "./theme";
import { useDispatch, useSelector } from "react-redux";
import AppScreenLoader from "../../components/AppScreenLoader";
import { useTranslation } from "react-i18next";
import { SET_MERCHANT } from "../../store/actions/actionTypes";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getCurrencies, getMerchants } from "../../store/actions";
import { formatNumber } from "../../utils";

const Home = () => {
  const accounts = useSelector(({ Auth }) => Auth.accounts);
  const account = useSelector(({ Auth }) => Auth.account);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getMerchants());
    dispatch(getCurrencies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (account && Object.keys(account).length) {
      navigate(`/home`);
    }
    if (accounts?.length === 0) navigate(`/home`);
    if (accounts?.length) setLoading(false)
  }, [account, accounts, navigate])
  
  if (loading) {
    return <AppScreenLoader />;
  }
  const handleMerchantSelection = (account) => {
    dispatch({
      type: SET_MERCHANT,
      payload: account,
    });
    navigate('/home');
  }
  return (
    <AppBaseScreen isHeader={true} showLocale={true} showMenu={false}>
      <ThemeProvider theme={theme}>
        <Container maxWidth='sm' sx={{ paddingTop: 5 }} disableGutters>
          <Box>
            <Typography variant="subtitle1" fontSize={14} paddingLeft={1} paddingRight={1} textAlign={'center'}>
              {t('chooseBusinessAccount')}
            </Typography>
          </Box>
          <List>
            {accounts?.length > 0 && accounts.map(account => (<ListItem key={account.merchantId} aria-label={account.merchantId} onClick={() => handleMerchantSelection(account)}>
              <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                <ListItemAvatar>
                  <Avatar sx={{ width: 42, height: 42, backgroundColor: '#27567c', fontSize: 16, }}>{account?.merchant?.companyName?.[0] || account?.merchant?.username?.[0]}</Avatar>
                </ListItemAvatar>
                <Box>
                  <ListItemText primary={account?.merchant?.companyName || account?.merchant?.username} sx={{ marginBottom: '0 !important' }} secondary={`Account# ${account?.payoutAccount?.accountRef}`} secondaryTypographyProps={{
                    color: '#DDDADA !important'
                  }} />
                  <Box display={'flex'} alignItems={'baseline'} justifyContent={'flex-start'}>
                    <Typography variant="subtitle1" fontSize={16} >{formatNumber(account?.totalBalance)}</Typography>
                    <Typography variant="subtitle1" fontSize={12} fontWeight={600} marginLeft={1}>{account?.payoutAccount?.configuration?.currency?.toUpperCase()}</Typography>
                  </Box>
                </Box>
              </Box>
              <ListItemSecondaryAction>
                <ArrowForward style={{ color: "#F8F8F8" }} />
              </ListItemSecondaryAction>
            </ListItem>))}
          </List>
          <Box>
            <Typography variant="subtitle1" fontSize={14} paddingLeft={1} paddingRight={1} textAlign={'center'}>
              {t('chooseBusinessAccount2')}
            </Typography>
          </Box>
        </Container>

      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Home;
